var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearningSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}.cls-1{stroke:currentColor;}.cls-2{stroke:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,68.36v77.88s30.47-12.93,57.87,4.61V72.36S61.42,52.35,30,68.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.08,68.36v77.88s-30.48-12.93-57.88,4.61V72.36S114.68,52.35,146.08,68.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,158.55s30.47-12.93,57.87,4.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.08,158.55s-30.48-12.93-57.88,4.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "166.98 84.34 192.55 105.7 167.88 126.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 60.57,
    y1: 105.7,
    x2: 190.44,
    y2: 105.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningSpeed);
export default __webpack_public_path__ + "static/media/LEARNING_SPEED.0bf3dc0c562697d66e49d1c944877541.svg";
export { ForwardRef as ReactComponent };